module.exports = __webpack_public_path__ + "img/bird-dog_1x.cc372be.png";


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/raf/bird-dog_1x.png
// module id = 684
// module chunks = 0